import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=9bd72bfe"
import script from "./PageLayout.vue?vue&type=script&lang=js"
export * from "./PageLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports